import React from 'react';
import {TextInput, Create, SimpleForm, required, minLength,BooleanInput, ReferenceInput, SelectInput} from 'react-admin';
import {makeStyles, Theme} from '@material-ui/core';
import BaseListActions from '../BaseListActions';
import {IP_LIST_TYPE, IP_LISTS} from '../../consts/Names';

const useStyles = makeStyles((theme: Theme) => ({
   formContainer: {
      width: '80%',
      padding: '0 1em 1em 1em'
   },
   textFld: {
      width: '300px',
      marginTop: '1em'
   }
}));

export const IpListCreate = (props) => {
   const {theme, basePath} = props;
   const classes = useStyles(theme);

   return (
      <Create {...props} actions={<BaseListActions basePath={basePath} />}>
         <SimpleForm className={classes.formContainer} redirect="list">
            <TextInput className={classes.textFld} label="IP" source={IP_LISTS.ip} />
            <TextInput className={classes.textFld} label="Description" source={IP_LISTS.description} />
            <SelectInput label="List Type" source={IP_LISTS.list_type} validate={[required()]} choices={IP_LIST_TYPE} />
         </SimpleForm>
      </Create>
   );
};
